import React from 'react';
import { autobind } from 'core-decorators';
import {
  FormFeedback,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
import InputMask from 'react-input-mask';

@autobind
class InputField extends React.Component {
  static defaultProps = {
    row: false,
  };

  handleChange(e) {
    this.props.model.requestChange &&
      this.props.model.requestChange(e.target.value);
  }

  render() {
    let {
      model,
      autoFocus,
      maxLength,
      placeholder,
      required,
      mask,
      type,
      disabled,
      componentClass,
      detail,
      row,
      addon,
      size,
      formGroupStyle,
      beforeMaskedValueChange,
      ...other
    } = this.props;

    let value = type == 'password' ? '******' : model.value;

    return (
      <FormGroup row={row} style={formGroupStyle}>
        {model.label && (
          <Label
            className={
              row &&
              'text-bold col-xl-2 col-md-3 col-4 col-form-label text-right'
            }
          >
            {model.label} {required ? '*' : ''}
          </Label>
        )}
        {detail ? (
          <div style={{ whiteSpace: 'pre' }} {...other}>
            {value}
          </div>
        ) : (
          <InputGroup size={size}>
            {mask ? (
              <InputMask
                autoFocus={autoFocus}
                disabled={disabled}
                type={type}
                required={required}
                placeholder={placeholder}
                value={model.value || ''}
                maxLength={maxLength}
                onChange={this.handleChange}
                mask={mask}
                beforeMaskedValueChange={beforeMaskedValueChange}
                className="form-control-sm form-control"
                invalid={model.errors}
                {...other}
              />
            ) : (
              <Input
                className={row && 'col-xl-10 col-md-9 col-8'}
                invalid={model.errors}
                autoFocus={autoFocus}
                disabled={disabled}
                type={type}
                required={required}
                placeholder={placeholder}
                value={model.value || ''}
                maxLength={maxLength}
                onChange={this.handleChange}
                componentclass={componentClass}
                {...other}
              />
            )}
            {addon && (
              <InputGroupText style={{ maxHeight: 31 }}>{addon}</InputGroupText>
            )}
          </InputGroup>
        )}
        {model.erros && <FormFeedback>{model.erros}</FormFeedback>}
      </FormGroup>
    );
  }
}

export default InputField;
